import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LangProvider } from './i18n';
import { AuthProvider, useAuth } from './auth';
import { ThemeProvider } from './theme';
import Layout from './components/Layout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Buy from './pages/Buy';
import Carry from './pages/Carry';
import Claim from './pages/Claim';
import Ops from './pages/Ops';
import Fleet from './pages/Fleet';
import Admin from './pages/Admin';
import Docs from './pages/Docs';
import Renew from './pages/Renew';

function Gate({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const { user, ready } = useAuth();
  if (ready && !user) return <Navigate to="/login" replace />;
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/fleet" element={<Fleet />} />
        <Route path="/carry" element={<Carry />} />
        <Route path="/claim" element={<Claim />} />
        <Route path="/renew/:policyId" element={<Renew />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/ops" element={<Gate roles={['adjuster', 'admin']}><Ops /></Gate>} />
        <Route path="/admin" element={<Gate roles={['admin']}><Admin /></Gate>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/*" element={<Gate><Shell /></Gate>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </ThemeProvider>
  );
}
